/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 29/3/2023
 */

import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useDeleteUserMutation } from "../../Store/Services/UserService";
import { closeUserModal } from "../../Store/Slices/userSlice";
import DeletePopUp from "../Shared/DeletePopUp";

const DeleteUser = () => {

    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);

    const [deleteUser] = useDeleteUserMutation();

    const onDeleteConfirm = async () => {
        console.log('Deleted...', user.selectedUser);
        const id = user.selectedUser;
        try {
            const deletedUser = await deleteUser(id).unwrap();
            console.log('deleted user', deletedUser)
            // toast.success("User successfully deleted!", { position: "bottom-right" });
        } catch (err) {
            console.error('Failed to delete the user: ', err)
            toast.error("Erorr, something went wrong!", { position: "bottom-right" });
        }
        dispatch(closeUserModal());
    }

    return (
        <DeletePopUp
            data="User"
            close={() => dispatch(closeUserModal())}
            onDeleteConfirm={onDeleteConfirm}
        />
    );
}

export default DeleteUser
